export enum CloudTelePhoneTypeEnum {
  KNOWLARITY = 1,
  MCUBE = 2
}
